/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export type IAPI73406ReqParamsObjMapValueObj = {};
    
  
    
export interface IAPI73406ReqParamsObj {
  
  /** String */
  mapKey?: IAPI73406ReqParamsObjMapKeyObj;
  
  /** Object */
  mapValue?: IAPI73406ReqParamsObjMapValueObj;
  
};
    
  
    
export interface IAPI73406ResFromObj {
  
  /**  */
  userType?: string;
  
  /**  */
  headImg?: string;
  
  /**  */
  nickName?: string;
  
  /**  */
  realName?: string;
  
};
    
  
    
export interface IAPI73406ResToObj {
  
  /**  */
  userType?: string;
  
  /**  */
  headImg?: string;
  
  /**  */
  nickName?: string;
  
  /**  */
  realName?: string;
  
};
    
  
    
export interface IAPI73406ResRecordsItemActionsItem {
  
  /**  */
  label?: string;
  
  /**  */
  value?: string;
  
  /**  */
  isSelect?: boolean;
  
};
    
  
    
export interface IAPI73406ResRecordsItem {
  
  /**  */
  sendTime?: string;
  
  /**  */
  content?: string;
  
  /**  */
  source?: string;
  
  /** ActionResp */
  actions?: IAPI73406ResRecordsItemActionsItem[];
  
};
    
  



export interface API73406Req {
  
  /** 场景：默认为default */
  scenes?: string;
  /** 子场景:业务带 */
  subScenes?: string;
  /** 是否带历史记录：默认false */
  withHistory?: string;
  /** 会话标识Id */
  sessionToken?: string;
  /** 场景：默认为default */
  scenes?: string;
  /** 子场景:业务带 */
  subScenes?: string;
  /** 是否带历史记录：默认false */
  withHistory?: boolean;
  /** 会话标识Id */
  sessionToken?: string;
  /** (该参数为map) */
  params?: IAPI73406ReqParamsObj;
};



export interface API73406Res {
  /**   */
  sessionToken?: string;
  /** HeadImgResp  */
  from?: IAPI73406ResFromObj;
  /** HeadImgResp  */
  to?: IAPI73406ResToObj;
  /** ChatRecordResp  */
  records?: IAPI73406ResRecordsItem[];
  
};


// 接口函数 73406 创建会话

export interface IUsePostAPI73406Return {
  /** 创建会话: 接口请求状态 */
  isAPI73406Loading: boolean;
  /** 创建会话: 接口请求返回数据 */
  dataAPI73406: API73406Res;
  /**  创建会话: 接口数据请求方法 */
  fetchAPI73406Data: (inputs: API73406Req, config?: YWRequestConfig) => Promise<API73406Res>;
  /** 创建会话: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI73406 = ():IUsePostAPI73406Return => {
  let isMount = true;
  const [isAPI73406Loading, setIsAPI73406Loading] = useState(false);
  const [dataAPI73406, setDataAPI73406] = useState<API73406Res>({} as API73406Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/session/create`;

  const fetchAPI73406Data = async (inputs: API73406Req, config?: YWRequestConfig): Promise<API73406Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API73406Req>) || {}) as API73406Req;
    
  
    if ( isMount ) {
      setIsAPI73406Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API73406Res>(`${basePath}/yoaichat-web/chat/session/create`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI73406(res || {} as API73406Res);
        setIsAPI73406Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI73406Loading(false);
      }
      return false as unknown as API73406Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI73406Loading,
    dataAPI73406,
    fetchAPI73406Data,
    requestUrl,
  }
}

